module.exports = __webpack_public_path__ + "media/images/athletes/597-ce8fc22451bfda08e49de08ff4142786.png";